export default {
  appCenter: {
    channel: "Canaux",
    riderApp: "App livreur",
    miniProgram: "Mini-programme WeChat",
    academy: "Académie",
    trainPlace: "Lieux de formation",
    ranking: "Classement",
    bond: "Caution",
    idCard: "Reconnaissance ID",
    sms: "SMS",
    remoteAttach: "Pièces jointes",
    mustSee: "À voir",
  },
  train: {
    title: "Formations",
    filterTitle: "Filtrer les lieux",
    place: "Lieu",
    placePh: "Saisir le lieu",
    type: "Type",
    addPlace: "Ajouter un lieu",
    name: "Nom",
    address: "Adresse",
    contact: "Contact responsable",
    trainDate: "Date",
    trainTime: "Horaire",
    enrollLimit: "Limite / inscrits",
    displayStatus: "Affichage",
    typeAll: "Tout",
    typeEntry: "Intégration",
    typeFull: "Temps plein",
    typeOther: "Autre",
  },
  learnings: {
    title: "Académie",
    participants: "Participants",
    typeAll: "Tout",
    typeEntry: "Intégration",
    typeSpecial: "Spécialisé",
    addBank: "Ajouter",
    bankTitle: "Titre",
    topicCount: "Questions",
    viewBank: "Voir",
    addSubject: "Nouvelle question",
    answerOptions: "Réponses",
    score: "Score",
  },
  ranking: {
    title: "Classement livreurs",
  },
  bond: {
    title: "Caution",
    list: "Liste caution",
    settingsTab: "Paramètres",
    amount: "Montant",
    paid: "Versée",
    refundApplying: "Demande de remboursement",
    refunded: "Remboursée",
    refundRejected: "Remboursement refusé",
    payTime: "Date",
    applyRefund: "Demande",
    refundedShort: "Remboursé",
    rejectRefund: "Refusé",
    settings: {
      customName: "Nom personnalisé",
      customNamePh: "Saisir le nom de la caution",
      amount: "Montant de la caution",
      amountPh: "Saisir le montant",
      refund: "Remboursement",
      refundDays: "Délai de remboursement (jours)",
      refundDaysPh: "Saisir le nombre de jours",
      dayUnit: "j",
      agreement: "Accord de caution",
      agreementPh: "Saisir l'accord",
      explain: "Description",
      explainPh: "Saisir la description",
    },
  },
  appSet: {
    title: "Liaison App livreur",
    subtitle: "Téléchargement et prise de commandes",
    viewTutorial: "Voir le tutoriel",
    step1Title: "Étape 1 : scanner ou télécharger l'App livreur",
    step1Desc1: "Le livreur doit d'abord télécharger l'App. Lien : ",
    step1Desc2: ", ou scanner le QR code à droite",
    step2Title: "Étape 2 : lier le domaine et l'ID plateforme",
    step2Desc1: "Avant inscription ou connexion, lier le domaine ",
    step2Desc2: " et l'ID plateforme : ",
    step2Desc3: " pour identification.",
    step3Title: "Étape 3 : inscription, certification, puis prise de commandes",
    step3Desc: "Configurez d'abord SMS et reconnaissance d'identité, sinon l'inscription échouera.",
    downloadNow: "Télécharger",
    preview: "Aperçu",
    configureNow: "Configurer",
  },
  miniappSet: {
    tabBasic: "Paramètres de base",
    tabUserList: "Utilisateurs",
    tabDownload: "Téléchargement",
    miniName: "Nom du mini-programme",
    miniNamePh: "Saisir le nom",
    miniAppId: "AppID (mini-programme)",
    miniAppIdPh: "Saisir AppID",
    miniSecret: "AppSecret",
    miniSecretPh: "Saisir AppSecret",
    appIdHint: "WeChat Public Platform → Développement → Paramètres → AppID",
    appSecretHint: "WeChat Public Platform → Développement → Paramètres → AppSecret",
    userInfo: "Utilisateur",
    linkedRider: "Livreur associé",
    regTime: "Inscription : ",
    step1Title: "Télécharger et installer les outils WeChat Dev (ignorer si déjà installé).",
    downloadDevTool: "Télécharger les outils Dev",
    step2Title: "Télécharger et décompresser le code du mini-programme.",
    downloadCodePack: "Télécharger le code",
    step3Title: "Ouvrir le projet dans les outils Dev, puis cliquer sur Téléverser.",
    validateMiniName: "Saisir le nom du mini-programme",
    validateAppId: "Saisir AppId",
    validateSecret: "Saisir AppSecret",
  },
  applicationList: {
    tools: "Outils",
    sms: "SMS",
    smsDesc: "Paramètres SMS Alibaba Cloud",
    remoteAttach: "Stockage distant",
    remoteAttachDesc: "Paramètres stockage cloud",
    mustConfig: "Requis",
  },
  activity: {
    title: "Activités",
    name: "Nom",
    namePh: "Saisir le nom",
    add: "Nouvelle activité",
    enrollTime: "Inscription",
    type: "Type",
    firstOrderReward: "Première commande",
    rushReward: "Bonus volume",
    completeOrders: "Commandes",
    completeReward: "Récompense",
    joinComplete: "Inscrits / réussis",
    status: "Statut",
    notStarted: "À venir",
    inProgress: "En cours",
    ended: "Terminée",
  },
  activityForm: {
    sort: "Tri",
    sortPh: "Plus petit = plus haut",
    namePh: "Saisir le nom",
    enrollTime: "Inscription",
    activityType: "Type",
    completeOrders: "Commandes",
    completeOrdersPh: "Commandes à compléter",
    completeReward: "Récompense",
    completeRewardPh: "Saisir la récompense",
    activityDate: "Dates",
    activityTime: "Heures",
    startTimePh: "Début",
    endTimePh: "Fin",
    addTimeSlot: "Ajouter période",
    activityDesc: "Description",
    sortRequired: "Tri requis",
    sortNumber: "Tri : nombre",
    nameRequired: "Nom requis",
    enrollTimeRequired: "Période inscription requise",
    typeRequired: "Type requis",
    conditionRequired: "Commandes requises",
    conditionNumber: "Commandes : nombre",
    rewardRequired: "Récompense requise",
    rewardNumber: "Récompense : nombre",
    activityTimeRequired: "Période activité requise",
    timeSlotIncomplete: "Complétez la période !",
  },
  appointment: {
    title: "Réservations",
    batchArrive: "Arrivée en lot",
    batchNotArrive: "Non arrivé en lot",
    enrollTime: "Inscription",
    arriveTime: "Arrivée",
    trainStatus: "Statut",
    pendingConfirm: "En attente",
    arrived: "Arrivé",
    notArrived: "Non arrivé",
    markArrived: "Arrivé",
    markNotArrived: "Non arrivé",
  },
  classify: {
    title: "Catégories",
    add: "Ajouter",
    edit: "Modifier",
    name: "Titre",
    namePh: "Saisir le titre",
    manage: "Catégories",
  },
  activityParticipants: {
    title: "Participants à l'activité",
    realName: "Nom réel",
    accountName: "Compte",
    enrollTime: "Inscription",
    completedOrders: "Commandes terminées",
    completeStatus: "Statut",
    completed: "Terminé",
    notCompleted: "Non terminé",
    rewardIssue: "Récompense",
  },
  examPass: {
    title: "Candidats ayant réussi",
    realName: "Nom réel",
    accountName: "Compte",
    enrollTime: "Inscription",
    status: "Statut",
    passed: "Réussi",
    notPassed: "Échoué",
    contact: "Contact",
  },
};
